import React, { useEffect, useState } from "react";
import Button, { ButtonProps } from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

interface IButtonCheckBox extends ButtonProps {
  allSelectedValues: (values: string[]) => void;
  values: string[];
  titleButton: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonCheckbox: {
      borderColor: "rgba(0, 0, 0, 0.23)",
      borderStyle: "solid",
      borderWidth: 1,
      height: 56,
    },
    labelNumber: {
      marginLeft: 3,
      borderRadius: "50%",
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      paddingInline: 4,
      paddingBlock: 2,
    },
  })
);

export default function ButtonCheckBox({ allSelectedValues, values, titleButton, ...props }: IButtonCheckBox) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    allSelectedValues(selectedValues);
  }, [selectedValues]);

  const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedValues([...selectedValues, event.target.name]);
    } else {
      selectedValues.includes(event.target.name) &&
        setSelectedValues([...selectedValues.filter((value) => value !== event.target.name)]);
    }
  };

  return (
    <>
      <Button
        {...props}
        className={classes.buttonCheckbox}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {titleButton}{" "}
        {!!selectedValues.length && <label className={classes.labelNumber}>{selectedValues.length}</label>}
      </Button>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <FormControl component="fieldset">
          <FormGroup>
            {values.length &&
              values.map((value, index) => (
                <MenuItem key={`${value}_${index}`}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={selectedValues.includes(value)}
                        onChange={handleSelect}
                        name={value}
                      />
                    }
                    label={value.replace(/_/g, " ")}
                  />
                </MenuItem>
              ))}
          </FormGroup>
        </FormControl>
      </Menu>
    </>
  );
}
